import terabyteImg from '../assets/terabyte.png';
import bingxImg from '../assets/bingx.webp';
import akhenatechImg from '../assets/akhenatech.jpeg';

export const parceiros = [
  {
    id: 'terabyte',
    name: 'Terabyte Shop',
    link: 'https://www.terabyteshop.com.br/promocoes?p=1551963',
    image: terabyteImg,
    description:
      'A Terabyteshop atua há 19 anos no mercado de tecnologia e informática, especializada em computadores e produtos de informática para todos os públicos. Focada no digital, é um dos maiores e-commerces do Brasil, com mais de 4Mi de acessos mensais ao site, além de ter presença em todos os principais marketplaces.',
  },
  {
    id: 'bingx',
    name: 'BingX',
    link: 'https://bingx.com/pt/partner/Akhenaton',
    image: bingxImg,
    description:
      'Fundada em 2018, a BingX é uma exchange de criptomoedas líder e empresa Web3-AI, atendendo uma comunidade global de mais de 40 milhões de usuários. Classificada entre as cinco principais exchanges globais de derivativos de cripto e pioneira em copy trading de criptomoedas, a BingX capacita usuários com ferramentas inovadoras projetadas para melhorar desempenho, confiança e eficiência.',
  },
  {
    id: 'akhenatech',
    name: 'Akhenatech',
    link: 'https://akhenatech.com/',
    image: akhenatechImg,
    description:
      'A Akhenatech desenvolve robôs de trading automatizado para Binance e BingX. Possui dois produtos ideais para dois perfis: estratégia pronta para quem está estruturando a operação (Akhenaton), e builder profissional para quem projeta estratégias próprias (Proteu).',
  },
];
